import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppProvider } from "../contexts";

export const AuthenticatedRoute = ({ element, auth }) => {
  const location = useLocation();

  if (!auth.isAuthenticated()) {
    return (
      <div
        style={{
          backgroundColor: "white",
          position: "fixed",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          zIndex: 1000
        }}
      >
        <Navigate
          to="/auth/login"
          state={{ from: location }}
          replace
        />
      </div>
    );
  }

  return (
    <AppProvider
      value={{
        loggedInUserId: auth.getUserId(),
        loggedInUserEmail: auth.getUserEmail()
      }}
    >
      {element}
    </AppProvider>
  );
};
